/* eslint-disable id-match */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CALENDAR_ON_REDEMPTION_NIGHTS } from '../../../../brands/default/content/components/deal';
import { setSelectedNights } from '../../../../redux/actions/bcor';
import CustomNativeSelect from '../../../_generic/custom-native-select/CustomNativeSelect';

const CalendarOnRedemptionNights = () => {
  const [nightOptions, selectedNights] = useSelector((state) => [
    state.bcor.nightOptions,
    state.bcor.selectedNights,
  ]);
  const dispatch = useDispatch();
  const { bcorStepOne, bcorStepOneSingleNight } = CALENDAR_ON_REDEMPTION_NIGHTS;

  const onChange = (event) => {
    dispatch(setSelectedNights(event.target.value));
  };

  if (!nightOptions || !Array.isArray(nightOptions)) return null;

  return (
    nightOptions && (
      <>
        <CustomNativeSelect
          ariaLabel={
            nightOptions.length === 1 ? bcorStepOneSingleNight : bcorStepOne
          }
          /* eslint-disable-next-line react/forbid-component-props */
          className="full-width margin"
          disabled={nightOptions.length === 1}
          id="num-nights"
          onChange={onChange}
          value={selectedNights}
        >
          {nightOptions.map((night) => {
            return (
              <option key={night.numberOfNights} value={night.numberOfNights}>
                {night.optionDisplay}
              </option>
            );
          })}
        </CustomNativeSelect>
      </>
    )
  );
};

export default CalendarOnRedemptionNights;
